// @ts-check
import { number, currency } from "vuetensils/src/filters";
export default {
  number,
  currency: (str) => currency(str, "USD"),
};
